import {gql} from 'apollo-boost'

export const GET_COUNTRIES = gql`
    query {
        countries {
            id
            name
        }
    }
`

export const ADD_COUNTRY = gql`
    mutation($name: String!) {
        createCountry(name: $name) {
            id
            name
        }
    }
`

export const UPDATE_COUNTRY = gql`
    mutation($id: ID! $name: String!) {
        updateCountry(id: $id name: $name) {
            id
            name
        }
    }
`

export const DELETE_COUNTRY = gql`
    mutation($id: ID!) {
        deleteCountry(id: $id) {
            name
        }
    }
`